import { gql } from "graphql-tag";

export const GET_ASSET_MODELS = gql`
  query GetAssetModels(
    $pagination: PaginationInput
    $filter: AssetModelFilterInput
    $sort: AssetModelSortInput
  ) {
    assetModels(pagination: $pagination, filter: $filter, sort: $sort) {
      data {
        id
        name
        modelNumber
        description
        manufacturer
        status
        voltage
        powerKw
        frequencyHz
        current
        protection
        accountId
        assetCategoryId
        assetCategory {
          id
          name
          description
          sortingOrder
          accountId
        }
        count {
          problemCategoryAssetModels
          maintenanceTemplates
          compatibleParts
          assets
        }
        createdAt
        updatedAt
      }
      meta {
        page
        limit
        total
        totalPages
        hasNext
        hasPrev
      }
    }
  }
`;

export const GET_ASSET_MODEL = gql`
  query GetAssetModel($id: ID!) {
    assetModel(id: $id) {
      id
      name
      modelNumber
      description
      manufacturer
      notes
      status
      voltage
      powerKw
      frequencyHz
      current
      protection
      weight
      dimensions
      energyEfficiencyClass
      standardFieldsVisibility
      accountId
      assetCategoryId
      assetCategory {
        id
        name
      }
      count {
        problemCategoryAssetModels
        maintenanceTemplates
        inspectionTemplates
        compatibleParts
        assets
        documents
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_ASSET_MODEL_MANUFACTURERS = gql`
  query GetAssetModelManufacturers($pagination: PaginationInput, $filter: AssetModelFilterInput) {
    assetModelManufacturers(pagination: $pagination, filter: $filter) {
      data
      meta {
        page
        limit
        total
        totalPages
        hasNext
        hasPrev
      }
    }
  }
`;
